/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import ListSequent from './ListSequent';
import ModalAddTag from './ModalAddTag';
import ModalRename from '../ModalRename';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';

export default function MainDetail() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [form] = Form.useForm();
    const notify = useNotify();

    const [openAddTag, setOpenAddTag] = useState(false);
    const [openRename, setOpenRename] = useState(false);

    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const result = [
        {
            groupId: '2a6fc2d73427491391328d0fe1d02948',
            nameTh: 'Barcode พ.ร.บ.',
            nameEn: 'Barcode พ.ร.บ.',
        },
        {
            groupId: 'c3b2f4379e864b5a86f9d9f0668fa1e0',
            nameTh: 'การศึกษา',
            nameEn: 'การศึกษา',
        },
        {
            groupId: 'fedfe1ff78924181be0f0056f19d0913',
            nameTh: 'ชื่อ, ชื่อกลาง, นามสกุล, นามแฝง ของผู้เอาประกันภัย ผู้ถือกรมธรรม์ประกันภัย และผู้รับประโยชน์',
            nameEn: 'ชื่อ, ชื่อกลาง, นามสกุล, นามแฝง ของผู้เอาประกันภัย ผู้ถือกรมธรรม์ประกันภัย และผู้รับประโยชน์',
        },
        {
            groupId: '5d7398f9295a4a7b97388d29e1de2919',
            nameTh: 'ทะเบียนรถยนต์ / หมายเลขตัวถัง / รุ่นรถยนต์',
            nameEn: 'ทะเบียนรถยนต์ / หมายเลขตัวถัง / รุ่นรถยนต์',
        },
    ];

    const consentFormsGenerator = (value) => {
        let dataForms = [];
        if (value?.length > 0) {
            for (let consent of value) {
                const consent_ = result.find((c) => c.groupId === consent);
                dataForms.push(consent_);
            }
        }
        return dataForms;
    };

    const onValuesChange = (change, values) => {
        if (values?.result) {
            let allItem = consentFormsGenerator(values?.result).filter(Boolean);
            if (allItem.length > 0)
                form.setFieldValue(
                    'dataForm',
                    consentFormsGenerator(values?.result)
                );
        }
    };

    return (
        <>
            <div className="p-8 bg-white rounded-md min-h-[500px]">
                <div className="flex justify-between">
                    <div className="flex flex-col">
                        <div className="flex items-center">
                            <span className="pr-2 font-semibold text-xl text-[#7B67FB]">
                                Personal Data{' '}
                            </span>
                            <span
                                className="pr-2 cursor-pointer"
                                onClick={() => {
                                    setOpenRename(true);
                                }}
                                style={{ height: 30 }}
                            >
                                {IconEdit}
                            </span>
                            <span
                                className="pr-2 cursor-pointer"
                                onClick={() => {
                                    console.log('DeleteIcon');
                                    setOpenDelete(true);
                                }}
                                style={{ height: 30 }}
                            >
                                {IconDelete}
                            </span>
                        </div>
                        <div className="font-semibold text-xs text-left text-[#65707A]">
                            {t('TotalItems', { length: 0 })}
                        </div>
                    </div>
                    <div>
                        <Button
                            className="w-[150px] text-tiny hover:bg-[#7B67FB]"
                            type="primary"
                            size="large"
                            onClick={() => setOpenAddTag(true)}
                        >
                            + {t('Add Tag')}
                        </Button>
                    </div>
                </div>
                <div
                    className="my-3"
                    style={{ borderBottom: '1px solid #DEDEE3' }}
                ></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    initialValues={{ dataForm: [] }}
                    form={form}
                    name="dataForms"
                    layout="vertical"
                    // onFinish={onFinish}
                    onValuesChange={onValuesChange}
                >
                    <ListSequent lang={lang} form={form} />
                </Form>
            </div>
            <ModalAddTag
                open={openAddTag}
                handelClose={() => setOpenAddTag(false)}
            />
            <ModalRename
                open={openRename}
                handelClose={() => setOpenRename(false)}
                data={{ name: 'Personal Data' }}
            />

            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={lang === 'en' ? 'Confirm delete?' : 'ยืนยันการลบข้อมูล?'}
                text={
                    lang === 'en'
                        ? `Do you want to delete Metadata Group ?`
                        : `คุณต้องการลบหมวดหมู่ Metadata หรือไม่`
                }
                handelOk={async () => {
                    setOpenDelete(false);

                    notify({
                        timeOut: 1000,
                        closeable: false,
                        title: t('Success'),
                        description: t('Successfully deleted data'),
                    });

                    // notify({
                    //     timeOut: 20000,
                    //     closeable: true,
                    //     type: 'error',
                    //     title: t('Fail'),
                    //     description: t('Failed to delete data'),
                    // });

                    // notify({
                    //     timeOut: 20000,
                    //     closeable: true,
                    //     type: 'error',
                    //     title: lang === 'en' ? 'Can’t delete this group' : 'หมวดหมู่นี้ไม่สามารถลบได้',
                    //     description: lang === 'en' ? 'There is still a list of tag under this group.' : 'เนื่องจากยังมีรายการแท็กอยู่ภายใต้หมวดหมู่นี้',
                    // });
                }}
                handelClose={() => {
                    setOpenDelete(false);
                    setLoadingDelete(false);
                }}
            />
            {/* <ModalRename
                form={form}
                loading={loading}
                open={openRename}
                handelClose={() => {
                    setOpenRename(false);
                    setLoading(false);
                }}
                handelOk={handelRename}
            /> */}
        </>
    );
}

const IconEdit = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#F3F6F9" />
        <path
            d="M20.6587 9.34131L22.6587 11.3413L21.134 12.8666L19.134 10.8666L20.6587 9.34131ZM13.3334 18.6666H15.3334L20.1914 13.8086L18.1914 11.8086L13.3334 16.6666V18.6666Z"
            fill="#7B67FB"
        />
        <path
            d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
            fill="#7B67FB"
        />
    </svg>
);
const IconDelete = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#F3F6F9" />
        <path
            d="M16 9C16.549 8.99992 17.0781 9.20504 17.4835 9.57509C17.8889 9.94513 18.1413 10.4534 18.1912 11H21.6C21.7521 11 21.8984 11.0578 22.0095 11.1616C22.1206 11.2654 22.1881 11.4074 22.1985 11.5591C22.2088 11.7108 22.1612 11.8607 22.0653 11.9786C21.9694 12.0966 21.8322 12.1737 21.6816 12.1944L21.6 12.2H21.1336L20.12 20.984C20.0749 21.3739 19.888 21.7336 19.5949 21.9947C19.3018 22.2558 18.923 22.4001 18.5304 22.4H13.4696C13.0771 22.4001 12.6983 22.2558 12.4052 21.9947C12.1121 21.7336 11.9252 21.3739 11.88 20.984L10.8656 12.2H10.4C10.2551 12.2 10.115 12.1475 10.0057 12.0522C9.89643 11.9569 9.82537 11.8252 9.80565 11.6816L9.80005 11.6C9.80005 11.455 9.85256 11.3149 9.94786 11.2057C10.0432 11.0964 10.1748 11.0253 10.3184 11.0056L10.4 11H13.8088C13.8587 10.4534 14.1112 9.94513 14.5166 9.57509C14.922 9.20504 15.4511 8.99992 16 9ZM14.8 14C14.604 14 14.44 14.124 14.4064 14.2872L14.4 14.3504V19.2504L14.4064 19.3128C14.44 19.476 14.604 19.6 14.8 19.6C14.996 19.6 15.16 19.476 15.1936 19.3128L15.2 19.2496V14.3512L15.1936 14.2872C15.16 14.1248 14.996 14 14.8 14ZM17.2 14C17.004 14 16.84 14.124 16.8064 14.2872L16.8 14.3504V19.2504L16.8064 19.3128C16.84 19.476 17.004 19.6 17.2 19.6C17.396 19.6 17.56 19.476 17.5936 19.3128L17.6 19.2496V14.3512L17.5936 14.2872C17.56 14.1248 17.396 14 17.2 14ZM16 10.2C15.516 10.2 15.112 10.544 15.02 11H16.98C16.8872 10.544 16.484 10.2 16 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
